import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type ContentType } from '@@api/utils/schemas/schemas';
import { getAuthorIdFromSearchValue } from '@@components/AuthorSearchableAutocomplete/utils';
import config from '@@config';
import { type ContentLanguage } from '@@lib/i18n/constants';

import { type OverviewListSearchParams } from './overviewListSearchParams';

const DEFAULT_SORT = 'updatedAt,desc';

// With a text, the API ranks by relevance unless the user picked a column
export const overviewListSort = (search: OverviewListSearchParams) =>
    search.sort ?? (search.q ? undefined : DEFAULT_SORT);

export const overviewListQuery = (
    contentType: ContentType,
    search: OverviewListSearchParams,
    contentLocale: ContentLanguage,
) =>
    client.metadata.metadata.getAll.queryOptions({
        query: {
            contentType,
            useSearch: true,
            q: search.q,
            sort: overviewListSort(search),
            tenantIds: search.tenantIds?.join(','),
            userIds: search.userIds ? getAuthorIdFromSearchValue(search.userIds) : undefined,
            contentStatus: search.contentStatus,
            publicationStatus: search.publicationStatus,
            categoryIds: search.categoryIds?.join(','),
            tagIds: search.tagIds,
            publishedAfter: search.publishedAfter,
            publishedBefore: search.publishedBefore,
            page: (search.page ?? 1) - 1,
            size: config.list.itemsPerPage,
        },
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });
